export default {
  name: 'GTA',
  objectStore: 'backlog'
};